<template>
    <date-picker
        ref="deliveryDatePickerRef"
        required="required"
        value-type="MM/DD/YYYY"
        id="delivery_date"
        type="date"
        autocomplete="asdf"
        :lang="lang"
        :default-value="season_start_at"
        :disabled-date="disabledDays"
        @change="focusNextButton"
        @panelChange="updatePopover"
        v-model="delivery_date"
        inline
        format="MM-DD-YYYY">
    </date-picker>
</template>
<script>
import DatePicker from 'vue2-datepicker-latest'
import {mapState, mapGetters} from "vuex";
export default {
    name: 'DeliveryDatePicker',
    components: {DatePicker},
    mounted(){
        let _this = this;
        const thElements = document.querySelectorAll('.mx-calendar thead tr th');

        //calendar weeks replace "Mo => M, "SU => S"
        thElements.forEach((th) => {
            const text = th.textContent;
            th.textContent = text.charAt(0);
        });


        $('#delivery_date').mouseover(function() {
           _this.updatePopover();
        });
    },
    data(){
        return {
            lang: {
                monthFormat: 'MMMM',
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                weeks: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
            },
        };
    },
    computed:{
        delivery_date: {
            get () {
                return this.$store.state.form.delivery_date;
            },
            set (value) {
                value = moment(value).format('MM/DD/YYYY')
                this.$store.dispatch('setDeliveryDate', {'delivery_date': value})
                this.$store.commit('SET_DELIVERY_DATE', value)
                this.$store.commit('SET_FIRST_DAY_SKIING')
                // this.$store.state.packages = []; //needs to reset if rental length get changed it effects on prices.
                this.$store.state.cart.packages = []; //needs to reset if rental length get changed it effects on prices.
            }
        },
        season_start_at(){
            return this.$store.state.form.first_day_skiing;
        },
        ...mapState(['season_start_at', 'season_end_at']),
        ...mapGetters(['getResortPhone']),
    },
    methods:{
        //step1 methods
        disabledDays(value) {
            let season_start_date = this.season_start_at
            let date = new Date(value);
            if (moment(date).isBefore(season_start_date)) {
                return true;
            }
        },

        focusNextButton(){
            let ele = document.getElementById('delivery-select');
            if(ele){
                this.cursorFocus(ele, 'nearest')
            }
        },
        cursorFocus(elem, block='nearest') {
            setTimeout(() => {
                const dropdownMenu = elem.closest('.bs3-drp-menu');
                if (dropdownMenu) {
                    dropdownMenu.scrollTop = dropdownMenu.scrollHeight;
                }
                elem.focus();
                elem.scrollIntoView({behavior: "smooth", block: block});
            }, 100);
        },

        updatePopover(){
            let _this = this;
            const datepicker = $(_this.$refs.deliveryDatePickerRef.$el);
            const content = 'Online reservations are not available on this date, Please call us at ' + _this.getResortPhone + ' to book rentals.';
            datepicker.find('td.disabled').each(function () {
                let title = $(this).attr('title');
                let titleDate = new Date(title);
                let yesterdayDate = moment().subtract(1, 'day');
                if (moment(titleDate).isAfter(yesterdayDate) && $(this).hasClass('disabled')) {
                    // perform your desired action on each td element
                    $(this).prop('title', content);
                }
            });
        }
    }
}
</script>
